import { footerLogoUrl, createTranslator } from "@/lib/constants";

export const Footer = ({ language }) => {
  const t = createTranslator(language);
  return (
    <footer className="bg-[#0F172A] text-slate-300 py-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        <div className="flex items-start gap-3" data-testid="footer-brand">
          <img
            loading="lazy"
            src={footerLogoUrl}
            alt="Infraglobal Engineering logo"
            className="h-12 w-auto flex-shrink-0"
            data-testid="footer-logo"
          />
          <div data-testid="footer-text">
            <p className="text-sm leading-relaxed">
              Website Designed, Developed &amp; Maintained by IGEL – Infraglobal Engineering Pvt. Ltd.
            </p>
            <p className="text-sm leading-relaxed mt-1">
              Copyright &copy; 2026 IGEL – Infraglobal Engineering Pvt. Ltd. All Rights Reserved.
            </p>
          </div>
        </div>
        <div className="md:text-right flex-shrink-0" data-testid="footer-links">
          <p className="text-sm leading-relaxed" data-testid="footer-note">
            Committed to transparency, compliance,
            <br className="hidden sm:inline" /> and nation-building infrastructure.
          </p>
        </div>
      </div>
    </footer>
  );
};
